module.exports = __webpack_public_path__ + "assets/img/laptop-amps-home.9c84c86c.png";